<div>
    <button mat-button type="button" color="primary" (click)="editInitialState()" i18n>Edit initial state</button>
    {{ getStateTitle(initialState.state )}}
  </div>
